import { Link } from 'react-router-dom';
import { videoArticles } from '@/mocks/home';

export default function VideoRecommend() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950">
            热门<span className="italic text-primary-600">视频</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-md mx-auto">
            黑料在线视频专区，独家现场实拍与直播录屏
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {videoArticles.map((video) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="group relative aspect-[4/3] rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={video.imageUrl}
                alt={video.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 md:w-16 md:h-16 rounded-full bg-white/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all">
                <i className="ri-play-fill text-2xl md:text-3xl text-primary-600 group-hover:text-white ml-0.5"></i>
              </div>
              <div className="absolute top-3 right-3 px-2 py-0.5 rounded bg-black/60 text-white text-xs font-medium backdrop-blur-sm whitespace-nowrap">
                {video.duration}
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="text-xs text-accent-400 font-medium mb-1 block">{video.category}</span>
                <h3 className="text-sm md:text-base font-semibold text-white line-clamp-2 leading-snug">
                  {video.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}